import React, { useEffect, useState } from "react";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import "./index.css";
interface RedirectCheckoutProps {
  signedFields: any;
  onComponentLoaded?: (loaded: boolean) => void;
  customerId: string;
  orderId: string;
  orderReference: string;
  paymentUrl?: string;
}

const RedirectCheckout: React.FC<RedirectCheckoutProps> = ({
  signedFields,
  onComponentLoaded,
  customerId,
  orderId,
  orderReference,
  paymentUrl
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (signedFields && onComponentLoaded) onComponentLoaded(true);
    return () => onComponentLoaded?.(false);
  }, [signedFields, onComponentLoaded]);
  const handlePaymentRedirect = () => {
    if (!signedFields || isSubmitting) return;
    setIsSubmitting(true);

    const form = document.createElement("form");
    form.method = "post";
    form.action =
      paymentUrl ??
      "https://secureacceptance.cybersource.com/pay";

    Object.entries(signedFields).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
      }
    });

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <Container fluid className="py-3 px-2 px-md-4">
      <Row className="justify-content-center">
        <Col xs={12} sm={12} md={12} lg={10} xl={7}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-3 p-md-4">
              {/* Header */}
              <div className="text-center mb-3 mb-md-4">
                <i
                  className="fas fa-credit-card text-success mb-2"
                  style={{ fontSize: "2rem" }}
                  aria-hidden="true"
                />
                <h2 className="fw-bold text-dark mb-3">Complete Your Payment</h2>
                <p className="text-muted mb-0">
                  You’ll be redirected to our secure payment gateway.
                </p>
              </div>

              {/* Summary (mobile-friendly spacing) */}
              {/* <div className="bg-light rounded-3 p-3 p-md-4 mb-3 order-summary">
                <Row className="summary-row">
                  <Col xs={6} sm={5} md={4}>
                    <span className="text-muted">Order Reference</span>
                  </Col>
                  <Col xs={6} sm={7} md={8} className="text-sm-end">
                    <span className="fw-semibold order-ref-text">
                      {orderReference || "--"}
                    </span>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col xs={6} sm={5} md={4}>
                    <span className="text-muted">Total Amount</span>
                  </Col>
                  <Col xs={6} sm={7} md={8} className="text-end">
                    <span className="fw-bold mb-0 amount-text">
                      {signedFields?.currency || ""} {signedFields?.amount || ""}
                    </span>
                  </Col>
                </Row>
              </div> */}
              <div className="bg-light rounded-3 p-3 p-md-4 mb-3 order-summary">
                {/* Order Reference */}
                <div className="d-flex justify-content-between align-items-center mb-2 mb-md-3">
                  <span className="text-muted">Order Reference</span>
                  <span className="fw-semibold order-ref-text text-end">
                    {orderReference || "--"}
                  </span>
                </div>

                {/* Total Amount */}
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">Total Amount</span>
                  <span className="fw-bold amount-text text-end">
                    {signedFields?.currency || ""} {signedFields?.amount || ""}
                  </span>
                </div>
              </div>

              {/* CTA (big, full-width on mobile) */}
              <div className="d-grid">
                <Button
                  onClick={handlePaymentRedirect}
                  size="lg"
                  className="pay-now-button fw-semibold py-3"
                  disabled={!signedFields || isSubmitting}
                  aria-busy={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Redirecting…
                    </>
                  ) : (
                    <>
                      <i className="fas fa-lock me-2" aria-hidden="true" />
                      Pay Now Securely
                    </>
                  )}
                </Button>
              </div>

              {/* Trust badge */}
              <div className="mt-3 text-center">
                <small className="text-muted d-inline-flex align-items-center">
                  <i className="fas fa-shield-alt me-1" aria-hidden="true" />
                  Secured by CyberSource
                </small>
              </div>

              {/* Missing fields guard */}
              {!signedFields && (
                <div className="mt-3">
                  <div className="alert alert-warning mb-0 small" role="alert">
                    Payment details are missing. Please return to checkout and
                    try again.
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RedirectCheckout;
